import React from 'react';
// import s from './App.module.scss';
import { MainComponent } from './pages/MainComponent/MainComponent';
import { SelectJeep } from './pages/SelectJeep/SelectJeep';
import { assetID, PAGE_NAME } from './utils/constants';
// import { TrebleApp, useProductCache } from '@threekit-tools/treble';
// import useImage from './hooks/useImage';
// import image from `./../public/1.jpg`;
// import {
//   ConfiguratorApp,
//   MainPage,
// } from '@elementalsweb/quadratec-3d-configurator';
import { Routes, Route } from 'react-router-dom';

const App = () => {
  // const { pathname } = useLocation();
  // const { loading, error, image } = useImage('1.jpg');

  // let navigate = useNavigate();

  // function handleSubmit(path) {
  //   navigate(path, { replace: true });
  // }

  // useEffect(() => {
  //   console.log('pathname: ', pathname);
  // }, [pathname]);
debugger
  return (
    // <div className="App">
    //   <Routes>
    //     <Route
    //       path="/Jeep2DoorJL"
    //       element={
    //         <ConfiguratorApp
    //           configSettings={{
    //             publicToken: 'e5bbde08-93d9-476f-9e2c-2017bd1f4d9d',
    //             orgId: '8f670b9f-76f4-4518-8d63-5eb6a728ed7d',
    //             assetId: 'b4c0d1c1-5d42-4911-8e6f-74542819a099',
    //             threekitEnviroment: 'preview',
    //           }}
    //           ReturnToMainPage={() => {
    //             window.location = '/';
    //           }}
    //           returnCartInfo={(info) => {
    //             console.log('info: ', info);
    //           }}
    //           customSettings={{}}
    //         />
    //       }
    //     />
    //     <Route
    //       path="/Jeep4DoorJL"
    //       element={
    //         <ConfiguratorApp
    //           configSettings={{
    //             publicToken: 'e5bbde08-93d9-476f-9e2c-2017bd1f4d9d',
    //             orgId: '8f670b9f-76f4-4518-8d63-5eb6a728ed7d',
    //             assetId: '8a2f2a42-5a37-42d4-bac7-af70aee47fc4',
    //             threekitEnviroment: 'preview',
    //           }}
    //           ReturnToMainPage={() => {
    //             window.location = '/';
    //           }}
    //           returnCartInfo={(info) => {
    //             console.log('info: ', info);
    //           }}
    //           customSettings={{}}
    //         />
    //       }
    //     />
    //     <Route
    //       path="/JeepGladiator"
    //       element={
    //         <ConfiguratorApp
    //           configSettings={{
    //             publicToken: 'e5bbde08-93d9-476f-9e2c-2017bd1f4d9d',
    //             orgId: '8f670b9f-76f4-4518-8d63-5eb6a728ed7d',
    //             assetId: '911943e5-41f0-4b56-bc85-adc4e310a7ea',
    //             threekitEnviroment: 'preview',
    //           }}
    //           ReturnToMainPage={() => {
    //             window.location = '/';
    //           }}
    //           returnCartInfo={(info) => {
    //             console.log('info: ', info);
    //           }}
    //           customSettings={{}}
    //         />
    //       }
    //     />
    //     <Route
    //       path="/"
    //       exact
    //       element={
    //         <MainPage
    //           OpenJeep2DoorJL={() => {
    //             handleSubmit('/Jeep2DoorJL');
    //           }}
    //           OpenJeep4DoorJL={() => {
    //             handleSubmit('/Jeep4DoorJL');
    //           }}
    //           OpenJeepGladiator={() => {
    //             handleSubmit('/JeepGladiator');
    //           }}
    //         />
    //       }
    //     />
    //   </Routes>
    // </div>

    // <>
    //   {pathname === '/' ? (
    //     <SelectJeep />
    //   ) : (
    //     <TrebleApp productId={assetID[pathname]} />
    //   )}
    // </>

    <Routes>
      <Route
        path={PAGE_NAME.Jeep2DoorJL}
        element={<MainComponent assetID={assetID[PAGE_NAME.Jeep2DoorJL]} />}
      />
      <Route
        path={PAGE_NAME.Jeep4DoorJL}
        element={<MainComponent assetID={assetID[PAGE_NAME.Jeep4DoorJL]} />}
      />
      <Route path={PAGE_NAME.home} element={<SelectJeep />} />
    </Routes>
  );
};

export default App;
